import {Injectable} from "@angular/core";
import {HttpService} from "../../technique/http.service";
import {Observable, Subject} from "rxjs";
import RegroupementPlatDTO from "../../../dtos/conditionnement/regroupement-plat-d-t-o";
import {
  RegroupementPlatFilterMl
} from "../../../models/gestion-conditionnements/regroupement/plat/regroupement-plat-filter-ml";
import {RegroupementPlatML} from "../../../dtos/conditionnement/regroupement-plat-ml";
import {ProduitDTO} from "../../../dtos/produit-dto";
import {ResponseWrapper} from "../../../suppliers/wrappers/response-wrapper";
import PointDeLivraisonRegroupementPlatDTO
  from "../../../dtos/conditionnement/point-de-livraison-regroupement-plat-dto";
import {
  ErreurParametrageRegroupementPlatMl
} from "../../../models/gestion-conditionnements/regroupement/plat/erreur-parametrage-regroupement-plat-ml";

export const URL_GET_REGROUPEMENT_PLAT = 'dolrest/conditionnements/regroupement-plat/findByFilter';
export const URL_SAVE_REGROUPEMENT_PLAT = 'dolrest/conditionnements/regroupement-plat/save';
export const URL_DELETE_REGROUPEMENT_PLAT = 'dolrest/conditionnements/regroupement-plat/delete';
export const URL_DELETE_PLAT = 'dolrest/conditionnements/regroupement-plat/plat/delete'
export const URL_SAVE_PLAT =  'dolrest/conditionnements/regroupement-plat/plat/save'
export const URL_GET_ALL_PLAT = 'dolrest/conditionnements/regroupement-plat/plat/list'
export const URL_SAVE_PLC_PRESTATION = 'dolrest/conditionnements/regroupement-plat/plc/save'
export const URL_ADD_ALL_PLC_PRESTATION = 'dolrest/conditionnements/regroupement-plat/plc/addAll'
export const URL_DELETE_PLC_PRESTATION = 'dolrest/conditionnements/regroupement-plat/plc/delete'
export const URL_GET_PLC_PRESTATION = 'dolrest/conditionnements/regroupement-plat/plc/list'



@Injectable({
  providedIn: 'root'
})
export class RegroupementPlatService {

  private subjectRegroupementErrors = new Subject<ErreurParametrageRegroupementPlatMl[]>();
  subjectRegroupementErrors$ = this.subjectRegroupementErrors.asObservable();

  private subjectRegroupementAddPlats = new Subject<ProduitDTO[]>();
  subjectRegroupementAddPlats$ = this.subjectRegroupementAddPlats.asObservable();

  private subjectOpenAJoutPlat = new Subject<RegroupementPlatDTO>();
  subjectOpenAJoutPlat$ = this.subjectOpenAJoutPlat.asObservable();


  private subjectOpenAJoutPlc = new Subject<RegroupementPlatDTO>();
  subjectOpenAJoutPlc$ = this.subjectOpenAJoutPlc.asObservable();

  private subjectRegroupementAddPlc = new Subject<void>();
  subjectRegroupementAddPlc$ = this.subjectRegroupementAddPlc.asObservable();


  constructor(private httpSvc: HttpService) { }

  getRegroupementPlatByFilter = (filter: RegroupementPlatFilterMl): Observable<ResponseWrapper<RegroupementPlatDTO>> => {
    return this.httpSvc.post(`${URL_GET_REGROUPEMENT_PLAT}`, filter)
  }

  save = (regroupement: RegroupementPlatML) : Observable<ResponseWrapper<any>> => {
    return this.httpSvc.post(URL_SAVE_REGROUPEMENT_PLAT, regroupement)
  }

  delete = (idList: number[]) => {
    return this.httpSvc.delete(`${URL_DELETE_REGROUPEMENT_PLAT}/${idList}`)
  }

  addPlats = (idList: number[], idRegroupementPlat: number): Observable<ResponseWrapper<any>> => {
    return this.httpSvc.post(`${URL_SAVE_PLAT}/${idRegroupementPlat}`, idList)
  }

  announceRegroupementAddPlats = (plats: ProduitDTO[]) => {
    this.subjectRegroupementAddPlats.next(plats);
  };

  announceOpenAjoutPlat = (regroupementPlat: RegroupementPlatDTO) => {
    this.subjectOpenAJoutPlat.next(regroupementPlat);
  };

  deletePlat(idList: number[], idRegroupementPlat: number): Observable<ResponseWrapper<any>> {
    return this.httpSvc.delete(`${URL_DELETE_PLAT}/${idList}/${idRegroupementPlat}`)
  }

  getPlats(idRegroupementPlat: number): Observable<ResponseWrapper<ProduitDTO>> {
    return this.httpSvc.get(`${URL_GET_ALL_PLAT}/${idRegroupementPlat}`)
  }

  savePlcPrestations = (plcId: number, idPrestations: number[], idRegroupementPlat: number): Observable<ResponseWrapper<any>> => {
    return this.httpSvc.post(`${URL_SAVE_PLC_PRESTATION}/${idRegroupementPlat}/${plcId}`, idPrestations)
  }

  deletePlc = (idPlcList: number[], idRegroupementPlat: number): Observable<ResponseWrapper<any>> => {
    return this.httpSvc.delete(`${URL_DELETE_PLC_PRESTATION}/${idRegroupementPlat}/${idPlcList}` )
  }

  announceOpenAjoutPlc = (regroupementPlat: RegroupementPlatDTO) => {
    this.subjectOpenAJoutPlc.next(regroupementPlat);
  }

  announceRegroupementAddPlc() {
    this.subjectRegroupementAddPlc.next();
  }

  getPlcList(idRegroupementPlat: number): Observable<ResponseWrapper<PointDeLivraisonRegroupementPlatDTO>> {
    return this.httpSvc.get(`${URL_GET_PLC_PRESTATION}/${idRegroupementPlat}`)
  }

  addPlcPrestation = (plcList: number[], idRegroupementPlat: number, conviveList?: number[]) : Observable<ResponseWrapper<any>> =>  {
    const body = {idRegroupementPlat: idRegroupementPlat, plcList: plcList, conviveList : conviveList ? conviveList : []};
    return this.httpSvc.post(`${URL_ADD_ALL_PLC_PRESTATION}/${idRegroupementPlat}`, body)
  }

  announceErreurParametrage = (erreurs: ErreurParametrageRegroupementPlatMl[]) => {
    this.subjectRegroupementErrors.next(erreurs);
  }
}
